import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Bell } from '@element-plus/icons-vue';
export default {
  name: 'Layout',
  components: {
    Bell
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const userInfo = computed(() => store.getters['user/userInfo'] || {});
    const userAvatar = computed(() => userInfo.value.avatar || '');

    // 移动端抽屉菜单状态
    const menuOpen = ref(false);
    const isMobile = ref(false);
    let mq = null;
    const checkScreen = () => {
      isMobile.value = mq ? mq.matches : window.innerWidth <= 768;
      if (!isMobile.value) {
        menuOpen.value = false;
      }
    };
    onMounted(() => {
      mq = window.matchMedia('(max-width: 768px)');
      checkScreen();
      if (mq.addEventListener) {
        mq.addEventListener('change', checkScreen);
      } else {
        mq.addListener(checkScreen);
      }
    });
    onBeforeUnmount(() => {
      if (mq) {
        if (mq.removeEventListener) {
          mq.removeEventListener('change', checkScreen);
        } else {
          mq.removeListener(checkScreen);
        }
      }
    });
    // 移动端切换页面后自动收起抽屉
    watch(() => route.path, () => {
      if (isMobile.value) {
        menuOpen.value = false;
      }
    });

    // vhr 风格的 group 图标使用 FontAwesome 类名，这里转成 em 图标映射
    const groupIconMap = {
      'home-filled': 'el-icon-odometer',
      'user': 'el-icon-user',
      'office-building': 'el-icon-office-building',
      'setting': 'el-icon-setting'
    };
    const groupIconClass = icon => groupIconMap[icon] || 'el-icon-menu';

    // 当前激活菜单
    const activeMenu = computed(() => route.path);

    // 当前页标题（不含 dashboard）
    const currentRouteTitle = computed(() => route.meta && route.meta.title || '');

    // 权限路由
    const permissionRoutes = computed(() => {
      const routes = router.options.routes.find(r => r.path === '/')?.children || [];
      const userRole = store.getters['user/role'];
      return routes.filter(item => {
        if (item.meta?.hidden) {
          return false;
        }
        if (!item.meta?.roles) {
          return true;
        }
        return item.meta.roles.includes(userRole) || userRole === 'admin';
      });
    });

    // 按 group 分组成子菜单
    const menuGroups = computed(() => {
      const map = new Map();
      for (const item of permissionRoutes.value) {
        const group = item.meta.group || '其他';
        const groupIcon = item.meta.groupIcon || 'menu';
        if (!map.has(group)) {
          map.set(group, {
            title: group,
            groupIcon,
            children: []
          });
        }
        map.get(group).children.push({
          path: item.path,
          title: item.meta.title,
          icon: item.meta.icon
        });
      }
      return Array.from(map.values());
    });
    const menuIndex = path => path.startsWith('/') ? path : `/${path}`;
    const groupIndex = group => group.title;
    const goSettings = () => {
      router.push('/system/settings');
    };
    const handleCommand = async command => {
      switch (command) {
        case 'profile':
          router.push('/profile');
          break;
        case 'settings':
          router.push('/system/settings');
          break;
        case 'logout':
          try {
            await ElMessageBox.confirm('此操作将注销登录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
            await store.dispatch('user/logout');
            router.replace('/login');
            ElMessage.success('注销成功');
          } catch (error) {
            // 用户取消
          }
          break;
      }
    };
    return {
      route,
      userInfo,
      userAvatar,
      menuGroups,
      activeMenu,
      currentRouteTitle,
      menuIndex,
      groupIndex,
      groupIconClass,
      menuOpen,
      isMobile,
      goSettings,
      handleCommand
    };
  }
};